import React from "react";
import { getLangFromPath } from "../i18n/lang";

import SilenceOverviewUk from "./static/SilenceOverviewPage.uk.jsx";
import SilenceOverviewEn from "./static/SilenceOverviewPage.en.jsx";
import SilenceOverviewIt from "./static/SilenceOverviewPage.it.jsx";
import SilenceOverviewFr from "./static/SilenceOverviewPage.fr.jsx";

export default function SilenceOverviewPage(props) {
  // язык из URL-префикса, fallback — uk
  const lang = getLangFromPath(window?.location?.pathname || "") || "uk";

  const Map = { uk: SilenceOverviewUk, en: SilenceOverviewEn, it: SilenceOverviewIt, fr: SilenceOverviewFr };


  const Comp = Map[lang] || SilenceOverviewUk;

  return <Comp {...props} />;
}
